import React from 'react';
import { useTranslation } from 'react-i18next';

const SIZE = { xs: 12, sm: 14, md: 18, lg: 24 };

export default function Spinner({ size = 'md', color, thickness = 2, style, ...rest }) {
  const { t } = useTranslation();
  const px = typeof size === 'number' ? size : (SIZE[size] ?? SIZE.md);
  return (
    <span
      role="status"
      aria-label={t('common.a11y.loading')}
      style={{
        display: 'inline-block',
        width: px,
        height: px,
        border: `${thickness}px solid var(--border)`,
        borderTopColor: color || 'var(--accent)',
        borderRadius: '50%',
        animation: 'spin 0.65s linear infinite',
        flexShrink: 0,
        ...style,
      }}
      {...rest}
    />
  );
}
